import styled from "styled-components";

export const IndexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ collapsed }) =>
    collapsed ? "calc(100vw - 1.98vw)" : "calc(100vw - 10.4vw)"};
  height: 100vh;
  margin-left: ${({ collapsed }) => (collapsed ? "3.96vw" : "0")};
  flex-wrap: wrap;
  gap: 3vw;
  padding: 2vh 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5em;
  border-radius: 20px;
  box-shadow: var(--shadow-sm);
  z-index: 2;
  width: 25vw;
  margin: auto;
  height: 80vh;
  margin-top: 4vh;
  overflow: hidden;
  gap: 1vh;
  margin-bottom: 2vh;
  margin-left: 2vw;
  margin-right: 2vw;
  padding-bottom: 2vh;

  h3 {
    display: flex;
    align-self: flex-start;
    color: var(--text-heading);
  }

  @media screen and (max-width: 70vw) {
    width: 90vw;
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

/**
 * export const Label = styled.label`
  font-weight: bold;
  font-size: 80%;
  color: var(--text-primary);
  margin-bottom: 1vh;
`;
 */

export const ShowInput = styled.input`
  width: 90%;
  height: 2.75vh;
  border: 0.052vw solid var(--border-default);
  border-radius: 0.417vw;
  padding: 0.417vw;
  font-size: 0.729vw;
  outline: none;
  background: var(--input-bg);
  transition: all 0.3s ease-in-out;
  color: var(--text-muted);

  &:focus {
    border-color: var(--accent);
    background: var(--surface-1);
    color: var(--text-primary);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

export const StyledSelect = styled.select`
  width: 100%;
  max-width: 18vw;
  height: 5vh;
  border: 0.052vw solid var(--border-default);
  border-radius: 0.417vw;
  padding: 0.417vw;
  font-size: 0.729vw;
  outline: none;
  background: var(--input-bg);
  transition: all 0.3s ease-in-out;
  margin-left: 0;
  color: var(--text-muted);

  &:focus {
    border-color: var(--accent);
    background: var(--surface-1);
    color: var(--text-primary);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2vh 5vw;
  margin-bottom: 1vh; /* espaço entre os Rows */
`;

export const LeftColumn = styled.div`
  padding: 2vh 5vw;
  display: flex;
  align-items: center;
  gap: 0.26vw;
  width: 48%;
`;

export const RightColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 0.26vw;
  width: 48%;
`;

/**
 * export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 2vh 5vw;
  text-align: right;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
 */

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 90%;
  font-family: "Inter", sans-serif;
  color: var(--text-primary);
`;

export const TableContainer = styled.div`
  width: 65vw;
  max-height: 60vh;
  overflow-y: auto;
  margin: 0 auto;
  margin-top: 2vh;
  border-radius: 20px;
`;

export const StyledButtonAdicionarUser = styled.button`
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 75%;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 7vw;
  height: 5vh;
  z-index: 1;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 130px;
    height: 30px;
  }
`;

export const Label = styled.label`
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 10pt;
  color: var(--text-primary);
`;

export const Input = styled.input`
  margin-bottom: 5px;
  border: 2px solid var(--border-default);
  border-radius: 4px;
  font-size: 12px;
  outline: none;
  width: 400px;
  background: var(--surface-glass);
  margin-top: 5px;

  &:focus {
    border-color: var(--accent);
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 44px;
    padding: 0.7rem 0.85rem !important;
    font-size: 16px;
    box-sizing: border-box;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

export const CollateralList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

export const CollateralItem = styled.li`
  margin-bottom: 10px;
`;
